import { Box, Typography } from '@mui/material';
import zeplinColor from 'theme/Color';

const GRID_MIN_HEIGHT = { xs: 'calc(100vh - 190px)', xl: 'calc(100vh - 200px)' };

const EmptyGrid = ({ variant }: { variant: 'default' | 'business' }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      minHeight: GRID_MIN_HEIGHT,
      width: '100%',
      px: 2,
    }}
  >
    <img src='/assets/leads-icon.svg' alt='' style={{ width: 88, height: 88 }} />
    <Typography
      variant='responsiveHeading3'
      color={zeplinColor.BasicBlack}
      sx={{ marginTop: { xs: '22px', xl: '24px' } }}
    >
      {variant === 'business' ? 'No Business Contacts' : 'No Contacts Yet'}
    </Typography>
    <Typography
      variant='responsiveBody3'
      color={zeplinColor.Neutral8}
      sx={{
        maxWidth: 420,
        marginTop: { xs: '10px', xl: '12px' },
      }}
    >
      {variant === 'business'
        ? 'There are no contacts to show for businesses yet. Try another search or check back later.'
        : 'Looks like there are no contacts here yet. New contacts will appear once added.'}
    </Typography>
  </Box>
);

export default EmptyGrid;
